import { render, staticRenderFns } from "./Clipping.vue?vue&type=template&id=114fdfdc&scoped=true&lang=pug&"
import script from "./Clipping.vue?vue&type=script&lang=js&"
export * from "./Clipping.vue?vue&type=script&lang=js&"
import style0 from "./Clipping.vue?vue&type=style&index=0&id=114fdfdc&lang=scss&scoped=true&"
import style1 from "./Clipping.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114fdfdc",
  null
  
)

export default component.exports